import React from 'react'
import './blogFilterChips.css'

export default function BlogFilterChips(props) {
  const {
    filterChips = [],
    selectedKeys = [],
    itemsVisible,
    selectedSearch = '',
    totalItems,
    handleBlogFilterSelection,
    handleClearFilters,
  } = props

  function renderFilterChips() {
    return (
      <div className="Chip-group u-marginTop3gu">
        {filterChips.map((filterChip) => {
          const { key = '', name = '' } = filterChip
          return (
            <div
              key={key}
              tabIndex="0"
              role="button"
              data-key={key}
              className={`Chip ${
                selectedKeys.indexOf(key) > -1 ? 'Chip--color active' : ''
              } u-textCapitalize`}
              data-analytics="insights-filters"
              onClick={() => handleBlogFilterSelection({ searchTopic: key })}
            >
              {name}
            </div>
          )
        })}
      </div>
    )
  }

  return (
    <div
      id="tab-filters"
      className="u-marginTop3gu u-sm-marginTop15gu blog-filter"
    >
      <h3 className=" u-textBold">Filter by:</h3>
      {renderFilterChips()}
      <div className="u-flex u-flexAlignItemsCenter u-flexJustifyBetween u-marginTop5gu u-marginBottom2gu">
        <div className="u-textSecondary">
          <p>
            Displaying <span className="u-textBold">{itemsVisible}</span> of{' '}
            <span className="u-textBold">{totalItems}</span> insights
          </p>
        </div>
        <div
          className={`Link u-textSecondary ${
            selectedKeys.length === 0 && !selectedSearch ? 'u-disabled' : ''
          }`}
          onClick={handleClearFilters}
        >
          Clear all filters
        </div>
      </div>
    </div>
  )
}
